<template>
  <Teleport to="body">
    <div
      v-if="helpOpen"
      class="fixed inset-0 z-[150] flex items-center justify-center bg-black/40 p-4"
      @click.self="helpOpen = false"
    >
      <div class="w-full max-w-md rounded-2xl bg-white p-5 shadow-lg dark:bg-gray-900" role="dialog" aria-modal="true" aria-label="میان‌برهای صفحه‌کلید">
        <div class="mb-4 flex items-center justify-between">
          <h3 class="text-base font-semibold text-gray-900 dark:text-white">میان‌برهای صفحه‌کلید</h3>
          <button type="button" class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800" aria-label="بستنِ پنجره" @click="helpOpen = false">✕</button>
        </div>
        <ul class="space-y-2">
          <li v-for="s in visibleShortcuts()" :key="s.label" class="flex items-center justify-between text-sm">
            <span class="text-gray-600 dark:text-gray-300">{{ s.label }}</span>
            <span class="flex gap-1" dir="ltr">
              <template v-for="(k, i) in s.keys" :key="i">
                <kbd class="rounded-lg border border-gray-300 bg-gray-50 px-1.5 py-0.5 font-mono text-xs text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200">{{ k }}</kbd>
                <span v-if="i < s.keys.length - 1" class="text-xs text-gray-400">سپس</span>
              </template>
            </span>
          </li>
        </ul>
        <!-- R3 is binary: a <p> is never `text-xs`. «12px is the floor, and 14px is the floor for
             anything with a verb in it», and this sentence has two. -->
        <p class="mt-4 text-center text-sm text-gray-400">برای بستن، <kbd class="font-mono" dir="ltr">Esc</kbd> را بزنید.</p>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { useKeyboardShortcuts } from '@/composables/useKeyboardShortcuts'

const { helpOpen, visibleShortcuts } = useKeyboardShortcuts()
</script>
